import React from 'react';

import styled from 'styled-components';

import { isLocalDevServer } from '~/shared/utils/helpers';

import AssetCardSkeleton from './AssetCardSkeleton';

const FallbackWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

const DevOverlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) =>
    theme.colors.gridAssetCardFallbackContentBackgroundColor};
  color: ${({ theme }) => theme.colors.gridAssetCardFallbackContentTextColor};
`;

const AssetCardFallback = () => {
  return (
    <FallbackWrapper>
      <AssetCardSkeleton />
      {isLocalDevServer && (
        <DevOverlay>Marketing Asset Not Available</DevOverlay>
      )}
    </FallbackWrapper>
  );
};

export default AssetCardFallback;
